import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import { getMaterialByCode } from '../../api/base/material'

export const headStyle = { background: '#f5f7fa', color: '#606266' }

export function today() {
  const d = new Date()
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
}

export function monthText(offset) {
  const d = new Date()
  d.setMonth(d.getMonth() + (offset || 0))
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1)
}

export const authMixin = {
  data() {
    return { permCodes: [], headStyle }
  },
  created() {
    this.loadPerms()
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() {
      fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {})
    }
  }
}

export function fillMaterialRow(row) {
  const code = (row.materialCode || '').trim()
  if (!code) return Promise.resolve()
  return getMaterialByCode(code).then(res => {
    const m = res.data
    if (!m || !m.materialId) {
      return null
    }
    row.materialId = m.materialId
    row.materialCode = m.materialCode
    row.materialName = m.materialName || ''
    row.customerCode = m.customerCode || ''
    row.specs = m.specs || ''
    row.barcodeManageMode = m.barcodeManageMode || 'none'
    if (!Array.isArray(row.serialNos)) row.serialNos = []
    return m
  })
}

export function loadAttributeText(row, vm) {
  const id = row && row.materialId
  const apply = text => {
    if (!row) return
    if (vm && vm.$set) vm.$set(row, 'materialAttributeText', text)
    else row.materialAttributeText = text
  }
  if (!id) {
    apply('')
    return Promise.resolve('')
  }
  return request.get('/base/material/attributeDisplayText', { params: { materialId: id } }).then(res => {
    const text = res.data || ''
    apply(text)
    return text
  }).catch(() => {
    apply('')
    return ''
  })
}

export function loadAttributeTexts(lines, vm) {
  return Promise.all((lines || []).filter(line => line && line.materialId).map(line => loadAttributeText(line, vm)))
}

export function downloadInventoryTemplate(kind, filename) {
  return request.get('/inventory/' + kind + '/importTemplate', { responseType: 'blob' }).then(res => {
    const blob = res.data instanceof Blob ? res.data : new Blob([res.data])
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  })
}

export function importInventoryLines(kind, file) {
  const form = new FormData()
  form.append('file', file)
  return request.post('/inventory/' + kind + '/importLines', form).then(res => {
    const data = res.data || {}
    const errors = data.errors || []
    if (errors.length) {
      const err = new Error('校验失败：' + errors.join('；'))
      err.errors = errors
      return Promise.reject(err)
    }
    return data.lines || []
  })
}

export function showImportError(vm, error) {
  const errors = error && error.errors
  if (Array.isArray(errors) && errors.length > 5) {
    vm.$notify({ title: '校验失败', message: errors.join('；'), type: 'error', duration: 0 })
    return
  }
  vm.$message.error((error && error.message) || '导入失败')
}

export function downloadCsv(filename, headers) {
  const bom = '\uFEFF'
  const text = bom + headers.join(',') + '\n'
  const blob = new Blob([text], { type: 'text/csv;charset=utf-8' })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  window.URL.revokeObjectURL(url)
}

export function readCsvFile(file) {
  return new Promise((resolve, reject) => {
    const name = (file && file.name) || ''
    if (/\.xlsx?$/i.test(name)) {
      reject(new Error('请使用下载的 CSV 模板导入'))
      return
    }
    const reader = new FileReader()
    reader.onload = () => resolve(String(reader.result || ''))
    reader.onerror = () => reject(new Error('读取文件失败'))
    reader.readAsText(file, 'utf-8')
  })
}

export function parseCsv(text) {
  const lines = String(text || '').replace(/^\uFEFF/, '').split(/\r?\n/).filter(line => line.trim())
  if (lines.length <= 1) return []
  const split = line => line.split(',').map(cell => cell.trim().replace(/^"|"$/g, ''))
  const header = split(lines[0])
  return lines.slice(1).map(line => {
    const cells = split(line)
    const row = {}
    header.forEach((key, i) => { row[key] = cells[i] || '' })
    return row
  })
}

export function pageSlice(list, pageIndex, pageSize) {
  const rows = list || []
  const start = (pageIndex - 1) * pageSize
  return rows.slice(start, start + pageSize)
}

export function postDoc(kind, body, id) {
  return request.post('/inventory/' + kind + (id ? '/update' : '/save'), body)
}

function lookupDefaultWarehouse(code) {
  const text = (code || '').trim()
  if (!text) return Promise.resolve('')
  return getMaterialByCode(text).then(res => {
    const m = res.data
    return (m && m.wareHouseId) || ''
  }).catch(() => '')
}

export function mergeQtyLines(lines, keyOf) {
  const mergedMap = {}
  const ordered = []
  ;(lines || []).forEach(line => {
    const key = keyOf(line)
    if (!key) return
    if (!mergedMap[key]) {
      mergedMap[key] = Object.assign({}, line)
      ordered.push(key)
    } else {
      const oldQty = Number(mergedMap[key].quantity || 0)
      mergedMap[key].quantity = Number((oldQty + Number(line.quantity || 0)).toFixed(2))
      if (mergedMap[key]._bomUnitQty == null || line._bomUnitQty == null) mergedMap[key]._bomUnitQty = null
    }
  })
  const merged = ordered.map(key => mergedMap[key])
  return { lines: merged, hadDuplicate: merged.length < (lines || []).length }
}

export function materialCodeKey(line) {
  return (line.materialCode || '').trim()
}

export function transferLineKey(line) {
  const code = (line.materialCode || '').trim()
  if (!code) return ''
  return code + '@@' + (line.fromWareHouseId || '').trim() + '@@' + (line.toWareHouseId || '').trim()
}

export function mergeCountingLines(lines, showSupplier) {
  const mergedMap = {}
  const ordered = []
  ;(lines || []).forEach(line => {
    const code = (line.materialCode || '').trim()
    const wh = (line.wareHouseId || '').trim()
    if (!code || !wh) return
    const sup = showSupplier ? (line.supplierId || line.supplierName || '').trim() : ''
    const key = showSupplier ? code + '@@' + wh + '@@' + sup : code + '@@' + wh
    if (!mergedMap[key]) {
      mergedMap[key] = Object.assign({}, line)
      ordered.push(key)
    } else {
      mergedMap[key].bookQuantity = Number((Number(mergedMap[key].bookQuantity || 0) + Number(line.bookQuantity || 0)).toFixed(2))
      mergedMap[key].actualQuantity = Number((Number(mergedMap[key].actualQuantity || 0) + Number(line.actualQuantity || 0)).toFixed(2))
    }
  })
  ;(lines || []).forEach(line => {
    const code = (line.materialCode || '').trim()
    const wh = (line.wareHouseId || '').trim()
    if (!code || !wh) {
      const key = '__raw__' + ordered.length
      mergedMap[key] = line
      ordered.push(key)
    }
  })
  const merged = ordered.map(key => mergedMap[key])
  return { lines: merged, hadDuplicate: merged.length < (lines || []).length }
}

export function fillMaterialDefaultWarehouses(form, options) {
  const opts = options || {}
  const tasks = []
  if (opts.product && form.productMaterialCode && !form.productWareHouseId) {
    tasks.push(lookupDefaultWarehouse(form.productMaterialCode).then(id => {
      if (id) form.productWareHouseId = id
    }))
  }
  ;(form.lines || []).forEach(line => {
    const code = (line.materialCode || '').trim()
    if (!code) return
    if (opts.skipLines || line.wareHouseId) return
    tasks.push(lookupDefaultWarehouse(code).then(id => {
      if (id) line.wareHouseId = id
    }))
  })
  return tasks
}
